import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getAllPageSections, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import "flatpickr/dist/flatpickr.css";
import ReactSelect from "react-select";
import ImagesUpload from "components/shared/ImagesUpload";
import { v4 } from "uuid";
import SlidersArray from "./SliderArray";
import { numInputValidations } from "helpers/functions";
import { Editor } from "components/shared/Editor";
import ImageUpload from "components/shared/ImageUpload";
import IconUpdate from "./iconUpdate";

const EditCategories = () => {
  const { formatMessage, locale } = useIntl();
  const [filteredCategories, setFilteredCategories] = useState([]);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loading, error, section, sections } = useSelector(
    (state) => state.section
  );
  const navigate = useNavigate();
  const [slider, setSlider] = useState([]);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [selectedIcon, setSelectedIcon] = useState({
    preview: null,
    path: "",
  });
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();
  // effects
  useEffect(() => {
    dispatch(getSection({ page: "categories-1", slug: id }));
  }, [dispatch, id]);

  // updating categories dropdown
  useEffect(() => {
    setFilteredCategories(() =>
      sections.filter((i) => i?.title === "categories")
    );
  }, [sections]);
  useEffect(() => {
    reset(section);

    let images = [];
    section?.images?.forEach((imagePath) => {
      const image = {
        id: v4(),
        preview: imagePath,
        path: imagePath,
      };
      images.push(image);
    });

    setSlider(images);
    // setFeatures(section.features);
  }, [reset, section]);
  useEffect(() => {
    reset(section);

    // setSliders(section?.sliders);
    setSelectedImage({
      preview: null,
      path: section?.image,
    });
    setSelectedIcon({
      preview: null,
      path: section?.icon,
    });
  }, [section]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.image = `${process.env.REACT_APP_URL}/uploads/${selectedImage?.path
      ?.split("/")
      .pop()}`;
    data.icon = `${process.env.REACT_APP_URL}/uploads/${selectedIcon?.path
      ?.split("/")
      .pop()}`;

    dispatch(
      editSection({
        slug: id,
        page: "categories-1",
        data: { section: data },
        navigate: () => navigate("/categories"),
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editItem"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"image"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"icon"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedIcon}
                      setSelectedImage={setSelectedIcon}
                    />
                  </div>
                </Col>
                <Row />
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="sectionTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="sectionTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="sectionDescription.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="description"
                    name="sectionDescription.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCategories;
